import * as i0 from '@angular/core';
import { inject, ElementRef, input, Directive, HostListener, APP_INITIALIZER, Injector, makeEnvironmentProviders } from '@angular/core';
import { ANALYTICS_PROVIDER, makeAttributes } from '@futura/futura-ui';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { map, tap } from 'rxjs/operators';
let AnalyticsButtonDirective = /*#__PURE__*/(() => {
  class AnalyticsButtonDirective {
    constructor() {
      this.analyticsService = inject(ANALYTICS_PROVIDER, {
        optional: true
      });
      this.elRef = inject(ElementRef);
      this.eventName = 'action_button_click';
      this.eventTitle = input();
      this.eventType = input('text');
      this.eventAction = input();
      /**
       * if action is navigation: destination url,
       * if action is dialog: dialog title,
       * if action is download: file name,
       * if action is update: insert/edit/delete - for mix cases use 'insert, edit'
       */
      this.eventTarget = input();
      this.eventAttributes = input();
    }
    getTitle() {
      const eventTitle = this.eventTitle();
      if (eventTitle) {
        return eventTitle;
      }
      const nativeElement = this.elRef.nativeElement;
      if (!(nativeElement instanceof HTMLElement)) {
        return undefined;
      }
      const childNodes = nativeElement.children;
      if (childNodes.length) {
        return undefined;
      }
      return nativeElement.textContent?.trim() || undefined;
    }
    onClick() {
      if (!this.analyticsService) {
        return;
      }
      const action = this.eventAction();
      const target = this.eventTarget();
      if (!action || !target) {
        return;
      }
      const title = this.getTitle();
      if (!title) {
        return;
      }
      const eventParams = {
        title,
        type: this.eventType(),
        action,
        target
      };
      const eventAttributes = this.eventAttributes();
      if (eventAttributes) {
        const attributes = makeAttributes(eventAttributes);
        if (attributes) {
          eventParams['attributes'] = attributes;
        }
      }
      this.analyticsService.sendAnalytics({
        eventName: this.eventName,
        eventParams
      });
    }
    static {
      this.ɵfac = function AnalyticsButtonDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AnalyticsButtonDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: AnalyticsButtonDirective,
        selectors: [["", "futAnalyticsButton", ""]],
        hostBindings: function AnalyticsButtonDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function AnalyticsButtonDirective_click_HostBindingHandler() {
              return ctx.onClick();
            });
          }
        },
        inputs: {
          eventTitle: [1, "eventTitle"],
          eventType: [1, "eventType"],
          eventAction: [1, "eventAction"],
          eventTarget: [1, "eventTarget"],
          eventAttributes: [1, "eventAttributes"]
        },
        standalone: true
      });
    }
  }
  return AnalyticsButtonDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function initAnalyticsNavigation(eventName, router, injector) {
  return () => {
    router.events.pipe(filter(event => event instanceof NavigationEnd), map(() => injector.get(ANALYTICS_PROVIDER, undefined)), filter(analytics => !!analytics), tap(analytics => analytics.sendAnalytics({
      eventName
    }))).subscribe();
  };
}
function analyticsNavigationProvider(eventName = 'view_page') {
  const providers = [];
  providers.push({
    provide: APP_INITIALIZER,
    useFactory: (router, injector) => initAnalyticsNavigation(eventName, router, injector),
    deps: [Router, Injector],
    multi: true
  });
  return makeEnvironmentProviders(providers);
}

/**
 * Generated bundle index. Do not edit.
 */

export { AnalyticsButtonDirective, analyticsNavigationProvider };
